import { User } from 'src/core/models';
import { getDetails, getList, remove, set } from 'src/core/redux/actions';
import LocalStorageService from 'src/core/services/LocalStoregeService';

import { config, state as stateConstants } from '../constants';

export const fetchUserDetails = () => async (dispatch) => {
  if (!config.isDevEnv) {
    await dispatch(
      getDetails(User, 'type', { url: User.getTypeConfig().url })()
    );

    const response = await dispatch(getList(User)());

    if (response.status === 200) {
      await dispatch(
        set(User.NAME, stateConstants.IDENTIFIER_TYPE_DETAILS, {
          data: { ...response?.consumers?.[0]?.user },
        })
      );
    }
  }
};

export const resetUserDetails = () => (dispatch) => {
  dispatch(remove(User.NAME, 'type'));
  dispatch(remove(User.NAME, 'details'));

  LocalStorageService.removeItem('loggedUser');
};
